import { render } from "./ViewFacilityOrderCountModal.vue?vue&type=template&id=f824f916&ts=true"
import script from "./ViewFacilityOrderCountModal.vue?vue&type=script&lang=ts"
export * from "./ViewFacilityOrderCountModal.vue?vue&type=script&lang=ts"

import "./ViewFacilityOrderCountModal.vue?vue&type=style&index=0&id=f824f916&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__